import { render, staticRenderFns } from "./BiddingAdviser.vue?vue&type=template&id=437c7b1e"
import script from "./BiddingAdviser.vue?vue&type=script&lang=js"
export * from "./BiddingAdviser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports